import axios from 'axios'
export const setAutoComplete = (state, payload) => state.autoComplete = payload
export const setUpdatePassword = (state, payload) => state.updatePassword = payload
export const setPermissoes = (state, payload) => state.permissoes = payload

export const setUsuario = function(state, usuario){
    state.usuario = usuario
}

